<template>
  <div ref="myChart" class="chart"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      title: "优",
      color: "#0ff",
      myChart: "",
    };
  },
  methods: {
    initChart() {
      let subTitle = "设备状态";
      this.$nextTick(() => {
        const _dashed = () => {
          let dataArr = [];
          for (var i = 0; i < 100; i++) {
            if (i % 2 === 0) {
              dataArr.push({
                name: (i + 1).toString(),
                value: 20,
                itemStyle: {
                  normal: {
                    color: this.color,
                  },
                },
              });
            } else {
              dataArr.push({
                name: (i + 1).toString(),
                value: 20,
                itemStyle: {
                  normal: {
                    color: "rgb(0,0,0,0)",
                    borderWidth: 1,
                    borderColor: this.color,
                  },
                },
              });
            }
          }
          return dataArr;
        };
        let option = {
          title: {
            text: "{a|" + this.title + "}\n{c|" + subTitle + "}",
            x: "center",
            y: "center",
            textStyle: {
              rich: {
                a: {
                  fontSize: 30,
                  color: "#fff",
                  fontWeight: "600",
                },
                c: {
                  fontSize: 16,
                  color: "#fff",
                  padding: [5, 0],
                },
              },
            },
          },
          series: [
            {
              type: "gauge",
              radius: "60%",
              clockwise: false,
              startAngle: "90",
              endAngle: "-269.9999",
              splitNumber: 30,
              detail: {
                offsetCenter: [0, -20],
                formatter: " ",
              },
              pointer: {
                show: false,
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: [
                    [0, "#2CFAFC"],
                    [0.1 / 100, this.color],
                    [1, "#0f232e"],
                  ],
                  width: 10,
                },
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                show: true,
                length: 100,
                lineStyle: {
                  shadowBlur: 10,
                  shadowColor: this.color,
                  shadowOffsetY: "0",
                  color: "#020f18",
                  width: 1,
                },
              },
              axisLabel: {
                show: false,
              },
            },
            {
              type: "pie",
              radius: ["44%", "45%"],
              hoverAnimation: false,
              clockWise: false,
              itemStyle: {
                normal: {
                  color: "#0C355E",
                },
              },
              label: {
                show: false,
              },
              data: _dashed(),
            },

            {
              type: "pie",
              radius: [0, "30%"],
              hoverAnimation: false,
              clockWise: false,
              itemStyle: {
                normal: {
                  shadowBlur: 20,
                  shadowColor: "#000",
                  color: new echarts.graphic.RadialGradient(0.4, 0.3, 1, [
                    {
                      offset: 0,
                      color: this.color,
                    },
                    {
                      offset: 1,
                      color: "#060f20",
                    },
                  ]),
                },
              },
              label: {
                show: false,
              },
              data: [100],
            },
            {
              type: "pie",
              radius: ["64%", "65.5%"],
              hoverAnimation: false,
              clockWise: false,
              itemStyle: {
                normal: {
                  shadowBlur: 20,
                  shadowColor: this.color,
                  color: "#0f232e",
                },
              },
              label: {
                show: false,
              },
              data: [100],
            },
            {
              type: "pie",
              radius: ["68%", "69.5%"],
              hoverAnimation: false,
              clockWise: false,
              itemStyle: {
                normal: {
                  shadowBlur: 20,
                  shadowColor: this.color,
                  color: "rgba(15, 35, 46,.6)",
                },
              },
              label: {
                show: false,
              },
              data: [100],
            },
          ],
        };

        if (this.myChart) echarts.dispose(this.myChart);
        this.myChart = echarts.init(this.$refs.myChart);
        this.myChart.setOption(option);
      });
    },
  },
  mounted() {
    this.initChart();
  },
};
</script>

<style scoped>
.chart {
  height: 100%;
  width: 100%;
}
</style>
